import classNames from 'classnames/bind';
import React from 'react';
import {
  Button, Col, Form, ListGroup, Row,
} from 'react-bootstrap';
import { useAchievementsContext } from '../../../../../../contexts/AchievementsContext/AchievementsContext';
import { AnswerAlternatePrice } from '../../../../../../dorian-shared/types/branch/AnswerStep';
import {
  CurrencyPreference,
} from '../../../../../../dorian-shared/types/CurrencyPreference/CurrencyPreference';
import { AnswerPrice } from '../AnswerPrice';
import styles from '../Steps.scss';

const cs = classNames.bind(styles);

export interface AnswerAlternatePriceItemProps {
  index: number;
  answerIndex: number;
  stepIndex: number;
  activeSteps: string;
  activeStepsFunc: (step: string) => void;
  value: AnswerAlternatePrice;
  onDelete: () => void;
  onChange: (e: React.ChangeEvent<HTMLInputElement>, field: keyof AnswerAlternatePrice) => void;
  currencyToggleSettings: CurrencyPreference;
}

export function AnswerAlternatePriceItem(props: AnswerAlternatePriceItemProps) {
  const {
    index,
    answerIndex,
    stepIndex,
    activeSteps,
    activeStepsFunc,
    value,
    onDelete,
    onChange,
    currencyToggleSettings,
  } = props;

  const { achievements } = useAchievementsContext();

  const activeStepString = `steps-${stepIndex}-answers-${answerIndex}-alternatePrices-${index}`;
  const isActive = activeSteps === activeStepString;

  const inputPartName = `steps[${stepIndex}][answers][${answerIndex}][alternatePrices][${index}]`;

  const handleAnswerPriceChange = (answerPrice: number) => {
    const newEvent = {
      target: {
        value: answerPrice,
      },
    } as unknown as React.ChangeEvent<HTMLInputElement>;
    onChange(newEvent, 'answerPrice');
  };

  return (
    <ListGroup.Item as="li" className={cs('p-0', 'branchesList-li')}>
      <Row className={cs('py-1', 'justify-content-between', { 'active-item': isActive })}>
        <Form.Group
          as={Col}
          controlId={`answer_${answerIndex}_alternatePrices${index}_key`}
          className={cs('mb-0')}
        >
          <Row>
            <Form.Label className={cs('text-right', 'px-1')} column md="auto">
              If Player Has
            </Form.Label>
            <Col className={cs('mb-0', 'px-1')}>
              <Form.Control
                size="sm"
                as="select"
                value={value.achievementId ?? 0}
                name={`${inputPartName}[achievementId]`}
                onFocus={() => activeStepsFunc(activeStepString)}
                onMouseDown={(e: React.MouseEvent<HTMLSelectElement>) => e.stopPropagation()}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => onChange(e, 'achievementId')}
              >
                <option value={0} disabled>N/A</option>
                {
                  achievements.map((achievement) => (
                    <option key={achievement.id} value={achievement.id}>
                      {achievement.name}
                    </option>
                  ))
                }
              </Form.Control>
            </Col>
          </Row>
        </Form.Group>

        <Form.Group
          as={Col}
          controlId={`answer_${answerIndex}_alternatePrices${index}_value`}
          className={cs('mb-0')}
        >
          <Row>
            <Col className={cs('mb-0', 'px-1')}>
              <AnswerPrice
                sm="auto"
                lg={9}
                xl={5}
                label="Custom Price"
                name={`${inputPartName}[answerPrice]`}
                answerIndex={answerIndex}
                stepIndex={stepIndex}
                answerPrice={value.answerPrice}
                handleChange={handleAnswerPriceChange}
                activeStepsFunc={activeStepsFunc}
                currencyToggleSettings={currencyToggleSettings}
                onFocus={() => activeStepsFunc(activeStepString)}
              />
            </Col>
          </Row>
        </Form.Group>
        <Col sm={2} xl={1} className="text-right">
          <Button
            data-testid={`deleteAltPrice-${stepIndex}-${answerIndex}-${index}`}
            className="ml-1 btnDeleteImgSm"
            size="sm"
            variant="secondary"
            onClick={onDelete}
            onFocus={() => activeStepsFunc(activeStepString)}
            onMouseDown={(e) => e.stopPropagation()}
          />
        </Col>
      </Row>
    </ListGroup.Item>
  );
}
